var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.1224 7.80746L17.9856 7.7293L16.6276 6.94769L13.8236 5.32586C12.9638 4.82758 11.6546 4.82758 10.7948 5.32586L7.99082 6.94769L6.63277 7.73907L6.45691 7.83677C4.70806 9.00919 4.59082 9.22413 4.59082 11.1098V15.6138C4.59082 17.4994 4.70806 17.7144 6.49599 18.9161L10.7948 21.3977C11.2247 21.6517 11.7621 21.769 12.3092 21.769C12.8466 21.769 13.3937 21.6517 13.8236 21.3977L18.1615 18.8868C19.9104 17.7144 20.0276 17.4994 20.0276 15.6138V11.1098C20.0276 9.22413 19.9104 9.00919 18.1224 7.80746Z",
    fill: "#D83A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.63379 7.73984L7.99183 6.94846L10.6688 5.40478L10.7959 5.32662C11.6556 4.82834 12.9648 4.82834 13.8246 5.32662L13.9516 5.40478L16.6286 6.94846L17.9867 7.73007V5.63926C17.9867 3.44099 16.7752 2.22949 14.5769 2.22949H10.0338C7.83551 2.22949 6.63379 3.44099 6.63379 5.63926V7.73984Z",
    fill: "#D83A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0842 13.3094L14.4785 14.0519C14.3808 14.1594 14.3124 14.3743 14.3221 14.5209L14.3808 15.4784C14.4198 16.0646 13.9997 16.3674 13.4526 16.1525L12.5635 15.8008C12.4267 15.7519 12.1923 15.7519 12.0555 15.8008L11.1664 16.1525C10.6193 16.3674 10.1992 16.0646 10.2382 15.4784L10.2969 14.5209C10.3066 14.3743 10.2382 14.1594 10.1405 14.0519L9.53479 13.3094C9.15376 12.86 9.31985 12.3617 9.88651 12.2151L10.8147 11.9807C10.9612 11.9416 11.1371 11.8048 11.2152 11.6778L11.7331 10.8766C12.0555 10.3784 12.5635 10.3784 12.8859 10.8766L13.4038 11.6778C13.4819 11.8048 13.6578 11.9416 13.8043 11.9807L14.7325 12.2151C15.2992 12.3617 15.4652 12.86 15.0842 13.3094Z",
    fill: "#D83A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.c67b9f14c0409fc044d9377244df971c.svg";
export { ForwardRef as ReactComponent };